import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import { Menu, Tab } from 'semantic-ui-react'
import { useAuth } from '~/routes/components/AuthProvider'
import { CLIMATE_CHECK_SLUG, CO2_LFL_SLUG, FAT_PROTEIN_SLUG, MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants'
import MilkFixedPriceDashboard from './Tabs/MilkFixedDashboard'
import CO2Dashboard from './Tabs/CO2Dashboard'
import FatProteinDashboard from './Tabs/FatProteinDashboard'
import StockExchangeDashboard from './Tabs/StockExchangeDashboard'
import ClimaCheckDashboard from './Tabs/ClimaCheckDashboard'
import MoohDashboard from './Tabs/MoohDashboard'
import MilkPriceDashboard from './Tabs/MilkPriceDashboard'

const Dashboard: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const { systemData: { modules, chEnv } } = useAuth()

  const [activeTabIndex, setActiveTabIndex] = useState<string | number>(0)

  const slugModules = modules.reduce((acc, module) => {
    acc[module.slug] = module
    return acc
  }, {})

  const hasMilkFixedModule = slugModules[MILK_FIXED_SLUG]
  const hasFatProteinModule = slugModules[FAT_PROTEIN_SLUG]
  const hasStockExchangeModule = slugModules[MILK_STOCK_EXCHANGE]
  const hasCo2Module = slugModules[CO2_LFL_SLUG]
  const hasClimaCheckModules = slugModules[CLIMATE_CHECK_SLUG]
  const hasMoohModule = chEnv === 1 || chEnv === true

  function renderDashboards() {
    const panes = [
      {
        menuItem: t('Milk Fixed Price'),
        render: () => <MilkFixedPriceDashboard />,
        display: hasMilkFixedModule,
        key: t('Milk Fixed Price')
      },
      {
        menuItem: t('Milk fixed price (F. & P.)'),
        render: () => <FatProteinDashboard />,
        display: hasFatProteinModule,
        key: t('Milk fixed price (F. & P.)')
      },
      {
        menuItem: t('Stock exchange'),
        render: () => <StockExchangeDashboard />,
        display: hasStockExchangeModule,
        key: t('Stock exchange')
      },
      {
        menuItem: <Menu.Item><div>CO<sub>2</sub> Klima Check</div></Menu.Item>,
        render: () => <CO2Dashboard />,
        display: hasCo2Module,
        key: 'Co2-klima-check'
      },
      {
        menuItem: <Menu.Item><div>Klima Check</div></Menu.Item>,
        render: () => <ClimaCheckDashboard />,
        display: hasClimaCheckModules,
        key: 'klima-check'
      },
      {
        menuItem: t('Milk money'),
        render: () => <MoohDashboard />,
        display: hasMoohModule,
        key: 'mooh'
      },
      {
        menuItem: t('Milk price'),
        render: () => <MilkPriceDashboard />,
        display: hasMoohModule,
        key: 'mooh-milk-price'
      }
    ];

    return <Tab
      menu={{ secondary: true, pointing: true }}
      activeIndex={activeTabIndex}
      panes={panes.filter(pane => pane.display)}
      onTabChange={(_, data) => setActiveTabIndex(data.activeIndex)}
    />
  }

  return <Layout
    segmented
    title={''}
    removeHeader
  >
    {renderDashboards()}
  </Layout>
}
export default Dashboard

